/**
 * Load js-money a JavaScript implementation of
 * Martin Fowlers Money pattern. https://www.npmjs.com/package/js-money
 */
export const MoneyProvider = {
  provide: 'Money',
  useValue: require('js-money'),
};
